import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export interface IClock {
    now(): Dayjs;
    today(): string;
    isToday(date: string): boolean;
    mockTime(time: string | Date | Dayjs): void;
    mockTimeZone(timeZone: string): void;
    mockTimeAndTimeZone(time: string | Date | Dayjs, timeZone: string): void;
    clearMock(): void;
    getMockStatus(): { time: string | null; timeZone: string | null };
}

export class Clock implements IClock {
    static inject = () => [];

    private mockedTime: Dayjs | null = null;
    private mockedTimeZone: string | null = null;

    now(): Dayjs {
        if (this.mockedTime) {
            return this.mockedTimeZone ? this.mockedTime.tz(this.mockedTimeZone) : this.mockedTime;
        }
        return dayjs();
    }

    today(): string {
        return this.now().format('YYYY-MM-DD');
    }

    isToday(date: string): boolean {
        return dayjs(date).isSame(this.now(), 'day');
    }

    // Instance methods for mocking through IOC
    mockTime(time: string | Date | Dayjs): void {
        this.mockedTime = dayjs(time);
        console.log(`🕐 Clock mocked to: ${this.mockedTime.toString()}`);
    }

    mockTimeZone(timeZone: string): void {
        this.mockedTimeZone = timeZone;
        console.log(`🌍 Timezone mocked to: ${timeZone}`);
    }

    mockTimeAndTimeZone(time: string | Date | Dayjs, timeZone: string): void {
        this.mockedTime = dayjs(time);
        this.mockedTimeZone = timeZone;
        console.log(`🕐🌍 Clock mocked to: ${this.mockedTime.toString()} in ${timeZone}`);
    }

    clearMock(): void {
        this.mockedTime = null;
        this.mockedTimeZone = null;
        console.log('⏰ Clock mock cleared - using real time');
    }

    getMockStatus(): { time: string | null; timeZone: string | null } {
        return {
            time: this.mockedTime?.toString() || null,
            timeZone: this.mockedTimeZone
        };
    }
};
